import type { CartProductInterface } from '@/types'

import { cartApiService } from './CartApiService'
import { cartCalculationService } from './CartCalculationService'
import { cartProductService } from './CartProductService'
import type {
  CartData,
  DeleteProductParams,
  UpdateProductQuantityParams,
} from './cartServiceTypes'
import { cartSortingService } from './CartSortingService'
import { cartValidationService } from './CartValidationService'

export class CartService {
  public readonly api = cartApiService
  public readonly validation = cartValidationService
  public readonly calculation = cartCalculationService
  public readonly product = cartProductService
  public readonly sorting = cartSortingService

  async fetchAndValidateCart(
    setProductsQuantity: (quantity: number) => void
  ): Promise<CartData> {
    const cart = await this.api.fetchCart(setProductsQuantity)
    return {
      ...cart,
      products: this.product.addOriginalIndex(cart.products),
    }
  }

  async deleteCheckedProducts(
    products: CartProductInterface[]
  ): Promise<CartData> {
    const orderableProducts = this.validation.filterOrderableProducts(products)

    if (orderableProducts.length === 0) {
      throw new Error('Нет доступных товаров для удаления')
    }

    return await this.api.deleteProducts(orderableProducts)
  }

  async deleteProductById(params: DeleteProductParams): Promise<CartData> {
    return await this.api.deleteProductById(params)
  }

  async updateProductQuantity(
    params: UpdateProductQuantityParams
  ): Promise<CartData> {
    return await this.api.updateItemQuantity(params)
  }

  async clearCart(): Promise<void> {
    await this.api.deleteCart()
  }

  prepareOrderProducts(products: CartProductInterface[]): {
    products: CartProductInterface[]
    error?: string
  } {
    const orderableProducts = this.validation.filterOrderableProducts(products)

    if (orderableProducts.length === 0) {
      return {
        products: [],
        error: 'Нет доступных товаров для заказа',
      }
    }

    const validationResult = this.validation.canCreateOrder()

    if (!validationResult.isValid) {
      return {
        products: [],
        error: validationResult.errorMessage,
      }
    }

    return { products: orderableProducts }
  }
}

export const cartService = new CartService()
